<div class="custom-amount__Wrapper">
    <h3 class="custom-amount--title">{{'customCashier.customAmountTitle' | translate }}</h3>
    <div class="custom-amount__panel">
        <div class="custom-amount--input">
            <div class="choose-amount--center">
                <span class="brite--currency-symbol symbol-left"  *ngIf='isCurrencyDefaultPosition'>{{userCurrency}}</span>
                <div id="inputAmount" #inputRef  class="input-content-editable" inputmode="decimal" contenteditable="true" appTwoDigitDecimaNumber (input)="onAmountChange($event)" >{{selectedAmount}}</div>
                <span  *ngIf='!isCurrencyDefaultPosition' class="amount--currency--symbol symbol-right" >{{userCurrency}}</span> 
            </div>
        </div>
        <div class="custom-amount__items">
            <button class="custom-amount--btn" [ngClass]="amountOne == selectedAmount ? 'active' : '' " (click)="onSelectAmount(inputRef,amountOne)">{{amountOne | currencyPipe:1}}</button>
            <button class="custom-amount--btn" [ngClass]="amountTwo == selectedAmount ? 'active' : '' " (click)="onSelectAmount(inputRef,amountTwo)">{{amountTwo | currencyPipe:1}}</button>
            <button class="custom-amount--btn" [ngClass]=" amountThree == selectedAmount ? 'active' : '' " (click)="onSelectAmount(inputRef,amountThree)">{{amountThree | currencyPipe:1}}</button>
        </div>
    </div>
</div>